/**
 * Выбор обоснования: список вариантов вместо поля ввода.
 *
 * **Почему не `<select>` и не радиокнопки браузера.** Варианты здесь —
 * предложения в одну-две строки («серединных перпендикуляров к сторонам»), а
 * не короткие ярлыки. В `select` они не читаются одновременно, а сравнить их
 * между собой — и есть работа ученика: вопрос ровно о том, чем одна линия
 * отличается от другой.
 *
 * **Ответом уезжает идентификатор, а не текст.** Текст меняется при пересборке
 * пула, а `attempts` не чистится никогда: строка журнала, ссылающаяся на текст
 * варианта, через месяц означала бы другое. Идентификаторы непрозрачны
 * (`c0…cN`) и перемешаны в каждой задаче — по ним ничего не угадать.
 *
 * **Текст варианта идёт через `Formula`.** В геометрии он сплошь несёт
 * обозначения: «\(AK\)», «\(\angle B\)». Без этого ученик видит в списке сырой
 * LaTeX — поймано просмотром готового листа задач, тестами не ловится.
 *
 * Клавиатура: варианты — обычные кнопки, поэтому Tab и Enter работают сами.
 * Отдельной обработки стрелок нет намеренно, она переопределила бы привычное
 * поведение ради четырёх пунктов.
 */

import { Formula } from "../lib/Formula";

export function Choices({
  options,
  value,
  onPick,
  disabled = false,
}: {
  options: { id: string; text: string }[];
  value: string;
  onPick: (id: string) => void;
  disabled?: boolean;
}) {
  return (
    <div className="choices" role="group" aria-label="варианты обоснования">
      {options.map((opt) => (
        <button
          key={opt.id}
          type="button"
          className={`choice${value === opt.id ? " choice--on" : ""}`}
          aria-pressed={value === opt.id}
          disabled={disabled}
          onClick={() => onPick(opt.id)}
        >
          <span className="choice__mark" aria-hidden="true" />
          <span className="choice__text">
            <Formula source={opt.text} />
          </span>
        </button>
      ))}
    </div>
  );
}
